export default __webpack_public_path__ + "static/media/slide31.ec80dbdd.png";